import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons'
import ReactGooglePlacesSuggest from "react-google-places-suggest"
import log from '../logger'

const googleMaps = window.google.maps;

class SearchField extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      search: "",
      value: "",
    }

    this.searchRef = undefined

    this.handleSelectSuggest = this.handleSelectSuggest.bind(this)
  }

  handleInputChange(text) {
    this.setState({search: text, value: text})
  }

  handleSelectSuggest(geocodedPrediction, originalPrediction) {
    log('handleSelectSuggest', geocodedPrediction, originalPrediction) // eslint-disable-line
    this.setState({search: "", value: geocodedPrediction.formatted_address})

    if (!geocodedPrediction.geometry) return;
    const lat = geocodedPrediction.geometry.location.lat()
    const lng = geocodedPrediction.geometry.location.lng()
    this.props.setHome(lat, lng)
  }

  manualSelect() {
    const value = this.state.value
    if (value.length === 0) return
    this.searchRef.geocodePrediction(value, geocodedPrediction => {
      log('manualSelect', geocodedPrediction)


      if (!geocodedPrediction.geometry) return;
      const lat = geocodedPrediction.geometry.location.lat()
      const lng = geocodedPrediction.geometry.location.lng()
      this.props.setHome(lat, lng)
      this.setState({search: "", value: geocodedPrediction.formatted_address})
    })
  }

  render() {
    return (
      <div className="SearchField">
        <button onClick={() => this.manualSelect()}><FontAwesomeIcon icon={faSearch}/></button>
        <ReactGooglePlacesSuggest
          ref={searchRef => this.searchRef = searchRef}
          googleMaps={googleMaps}
          autocompletionRequest={{
            input: this.state.search,
            // Optional options
            // https://developers.google.com/maps/documentation/javascript/reference?hl=fr#AutocompletionRequest
          }}
          // Optional props
          onSelectSuggest={this.handleSelectSuggest}
          textNoResults="Luogo non identificato" // null or "" if you want to disable the no results item
        >
          <input
            type="text"
            value={this.state.value}
            placeholder="Inserisci indirizzo, città o cap"
            onChange={e => this.handleInputChange(e.target.value)}
          />
        </ReactGooglePlacesSuggest>
      </div>
    );
  }
}

SearchField.propTypes = {
  setHome: PropTypes.func.isRequired,
};

export default SearchField;
